// LE VOCABULAIRE PARTAGÉ — le français que chaque page parle de la même voix : les verbes, les
// statuts, les priorités, les types d'exigence, les libellés de phase, les modèles commerciaux,
// les petits mots. Enregistré une fois depuis PageKit (toujours dans le bundle), pour qu'un
// catalogue de page n'ait pas à les répéter ; une page qui en répète un avec la MÊME valeur est
// sans conséquence, une valeur différente avertit.
import { registerFr } from './index.js';

registerFr({
  // ── verbes ──
  'Save': 'Enregistrer',
  'Cancel': 'Annuler',
  'Close': 'Fermer',
  'Delete': 'Supprimer',
  'Edit': 'Modifier',
  'Add': 'Ajouter',
  'New': 'Nouveau',
  'Remove': 'Retirer',
  'Search': 'Rechercher',
  'Revert': 'Abandonner',
  'Refresh': 'Actualiser',
  'Confirm': 'Confirmer',
  'Hold': 'Retenir',
  'Refuse': 'Refuser',
  'Amend': 'Adapter',
  'Restore': 'Rétablir',
  'Descope': 'Retirer du périmètre',
  'Sign': 'Signer',
  'Reading…': 'Chargement…',
  'Loading…': 'Chargement…',
  'Saving…': 'Enregistrement…',

  // ── les petits mots ──
  'nothing edited': 'aucune modification',
  'not named': 'sans nom',
  'not set': 'non défini',
  'undated': 'sans date',
  'none': 'aucun(e)',
  'The change was refused.': 'La modification a été refusée.',
  'working days': 'jours ouvrables',
  'due': 'échéance',
  'Due': 'Échéance',
  'Due date': 'Date d’échéance',
  'Start date': 'Date de début',
  'Currency': 'Devise',
  'Estimate': 'Estimation',
  'Budget': 'Budget',
  'Language': 'Langue',
  'Correspondence language': 'Langue de correspondance',

  // ── statuts (tels que le registre et les livrables les portent) ──
  'draft': 'brouillon',
  'Draft': 'Brouillon',
  'pending': 'en attente',
  'Pending': 'En attente',
  'confirmed': 'confirmé',
  'Confirmed': 'Confirmé',
  'baselined': 'dans la baseline',
  'Baselined': 'Dans la baseline',
  'delivered': 'livré',
  'Delivered': 'Livré',
  'accepted': 'accepté',
  'Accepted': 'Accepté',
  'accepted_with_edits': 'accepté avec modifications',
  'dropped': 'abandonné',
  'Dropped': 'Abandonné',
  'descoped': 'retiré du périmètre',
  'Descoped': 'Retiré du périmètre',
  'planned': 'planifié',
  'Planned': 'Planifié',
  'in progress': 'en cours',
  'in_progress': 'en cours',
  'In progress': 'En cours',
  'refused': 'refusé',
  'Refused': 'Refusé',
  'rejected': 'refusé',
  'Rejected': 'Refusé',
  'amended': 'adapté',
  'Amended': 'Adapté',
  'held': 'retenu',
  'Held': 'Retenu',
  'untreated': 'non traité',
  'treated': 'traité',

  // ── priorités ──
  'must': 'Doit',
  'should': 'Devrait',
  'could': 'Pourrait',
  "won't": 'Exclu',
  'wont': 'Exclu',
  'Must': 'Doit',
  'Should': 'Devrait',
  'Could': 'Pourrait',
  "Won't": 'Exclu',

  // ── types d'exigence ──
  'functional': 'fonctionnel',
  'non-functional': 'non fonctionnel',
  'non_functional': 'non fonctionnel',
  'constraint': 'contrainte',
  'assumption': 'hypothèse',
  'out of scope': 'hors périmètre',
  'out_of_scope': 'hors périmètre',
  'Functional': 'Fonctionnel',
  'Non-functional': 'Non fonctionnel',
  'Constraint': 'Contrainte',
  'Assumption': 'Hypothèse',
  'Out of scope': 'Hors périmètre',

  // ── phases (crm.PHASE_LABELS) ──
  'Qualify': 'Qualification',
  'Discovery': 'Discovery',
  'Design': 'Conception',
  'Contracting': 'Contractualisation',
  'Mobilise': 'Mobilisation',
  'Implement': 'Réalisation',
  'Acceptance': 'Acceptation',
  'Handover': 'Transfert',
  // la phase 'Close' (Clôture) n'entre pas en collision avec le verbe Close (Fermer) — contrairement
  // à l'allemand, aucune clé de contournement n'est nécessaire ici.

  // ── modèles commerciaux (crm.COMMERCIAL_MODEL_LABELS) ──
  'Fixed price': 'Forfait',
  'Time & materials': 'En régie',
  'Capped T&M': 'Régie plafonnée',
  'Retainer': 'Retainer',

  // ── acteurs ──
  'agent': 'agent',
  'operator': 'opérateur',
  'portal': 'portail',
  'Agent': 'Agent',
  'Operator': 'Opérateur',
  'Portal': 'Portail',
}, 'common');
